(function ($, App, Utils, Components, Pages) {
    'use strict';

    const logger = new Logger('Cart');

    Pages.create('Cart', {

        Cart: {
            updateTimer: undefined
        },

        Selectors: {
            removetocart: '.remove-to-cart',
        },

        loadCart: () => {
            axios.get('/action/cart/get').then(function (r) {
                Pages.Purchaseables.applyCart(r.data);
                $prod.addClass('ready');
                $(Pages.Purchaseables.Selectors.catalog).addClass('ready');
            }).catch(function (r) {

            });
        },

        applyCart: (cart) => {
            cart.entries.forEach((e) => {
                let $prodCount = Pages.Cart.selectProduct(e.productsGroup, e.productId, Pages.Cart.Selectors.cartCount),
                    amount = Math.max(e.count, 0);
                $prodCount.data('amount', amount);
                $prodCount.text(amount);
            });
            logger.info("Updated cart: ", cart);
        },

        bindEvents: () => {
            $(Pages.Cart.Selectors.removetocart).on('click', (e) => {
                let $this = $(e.target),
                    prodId = $this.data('code'),
                    catalogId = $this.data('catalog'),
                    amount = 0,
                    price = 0;
                Pages.Cart.deleteItemToCart(catalogId, prodId, amount,price);
                location.reload();
            });
        },

        updateCartCount: (catalogId, productId, amount,price) => {
            amount = Pages.Cart.setCount(catalogId, productId, amount);
            clearTimeout(Pages.Cart.Cart.updateTimer);
            Pages.Cart.Cart.updateTimer = setTimeout(() => Pages.Cart.updateCart(catalogId, productId, amount,price), 500);
        },

        setCount: (catalogId, productId, amount) => {
            let $prodCount = Pages.Cart.selectProduct(catalogId, productId, Pages.Cart.Selectors.cartCount);
            amount = Math.max(Number($prodCount.data('amount')) + amount, 0);
            $prodCount.data('amount', amount);
            $prodCount.text(amount);
            return amount;
        },

        selectProduct: (catalogId, productId, find) => {
            return $('#catalog-' + catalogId + ' #p-' + productId + (find || ''));
        },

        deleteItemToCart: (catalogId, productId, quantity, price) => {
            let $prod = Pages.Cart.selectProduct(catalogId, productId);
            Pages.Cart.updateEntry($prod);
            axios.post('/action/cart/delete', {
                catalogId: catalogId,
                productId: productId,
                quantity: quantity,
                price: price
            }).then(function (r) {
                Pages.Cart.applyCart(r.data);
                $prod.addClass('ready');
                $(Pages.Cart.Selectors.catalog).addClass('ready');
            }).catch(function (r) {

            });
        },

        updateEntry: (prod) => {
            $(Pages.Cart.Selectors.catalog).removeClass('ready');
            prod.removeClass('ready');
            $(Pages.Cart.Selectors.spinner).prependTo(prod.find('.spinner'));
        },

        init: () => {
            Pages.Cart.bindEvents();
        }

    });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components,
    window.App.Pages
);

